import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { set } from 'date-fns';

@Component({
    selector: 'ca-compact-form',
    templateUrl: './compact-form.component.html',
    styleUrls: ['./compact-form.component.scss'],
    standalone: false
})
export class CompactFormComponent implements OnInit, OnChanges {
  @ViewChild('formDirective')
  formDirective: FormGroupDirective;

  @Input()
  id: string;

  @Input()
  formGroup: any;

  @Output()
  submit = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formGroup'] && !changes['formGroup'].firstChange && this.formDirective) {
      this.formDirective.resetForm(this.formGroup.getRawValue());
    }
  }

  onSubmit(): void {
    this.submit.emit();
  }
}
